// angular.module("HeroPRO")

// 	.directive('hpInputType2',

export default function InputTypeCheckboxDirective() {
    return {
        restrict: 'E',
        templateUrl: 'app/productCenter/pages/productdetail/inputTypes/templates/checkbox.html',
        /* @ngInject */
        controller($scope, $rootScope, $timeout) {
            const vm = this;

            vm.dataSource = $scope.objectSource;
            vm.form = $scope.formSource;
            vm.selectedCheckboxes = [];


			    // Access form control object
            const currentFormId = `${vm.dataSource.TypeId}-${vm.dataSource.Deprecated_ProductAttributeNameId}`;
            vm.form[currentFormId] = {};
            vm.form[currentFormId].checkboxInvalid = !!vm.dataSource.IsRequired;
            vm.form[currentFormId].name = vm.dataSource.DisplayName;

            vm.checkboxValidation = function (model, option) {
				    vm.selectedCheckboxes = vm.selectedCheckboxes || [];

				    if (model) {
				        vm.selectedCheckboxes.push(option.InputOptionId);
				        /* jshint ignore:start */

				        vm.selectedCheckboxes = _.uniq(vm.selectedCheckboxes);
				    } else {
				        vm.selectedCheckboxes = _.without(vm.selectedCheckboxes, option.InputOptionId);
				        /* jshint ignore:end */
				    }

				    if (vm.selectedCheckboxes.length > 0 && vm.dataSource.IsRequired) {
				        vm.form[currentFormId].checkboxInvalid = false;
				    } else if (vm.selectedCheckboxes.length === 0 && vm.dataSource.IsRequired) {
				        vm.form[currentFormId].checkboxInvalid = true;
				    } else if (!vm.dataSource.IsRequired) {
				        vm.form[currentFormId].checkboxInvalid = false;
				    }

				    $timeout(() => {
				        $rootScope.$broadcast('inputTypesDirective.checkBoxValidation');
				    });
            };


            // Common
            vm.inputChanged = function () {
                $scope.inputChanged();
            };

            if ($scope.last) {
                $rootScope.$broadcast('inputTypesDirective.filtersLoaded');
            }
        },
        controllerAs: 'inputTypes',
    };
}



// WEBPACK FOOTER //
// ./src/app/productCenter/pages/productdetail/inputTypes/directives/inputTypeCheckboxDirective.js